document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.reviewItem__bio').forEach(bioEl => {
    const nameEl = bioEl.querySelector('.reviewItem__naam');
    const gemeenteEl = bioEl.querySelector('.reviewItem__gemeente');

    if (!nameEl) return;

    const nameText = nameEl.textContent.trim();
    const gemeenteText = gemeenteEl?.textContent.trim() || '';
    const totalLength = (nameText + ' uit ' + gemeenteText).length;

    // Voorwaarde: ofwel te lang, of gemeente is leeg
    if (totalLength > 24 || !gemeenteText) {
      // Verwijder gemeente <span> indien aanwezig
      if (gemeenteEl) gemeenteEl.remove();

      // Zoek tekstnode 'uit' direct na .reviewItem__naam
      let next = nameEl.nextSibling;
      while (next && next.nodeType !== Node.TEXT_NODE) {
        next = next.nextSibling;
      }

      if (next && next.textContent.trim().toLowerCase() === 'uit') {
        next.remove();
      }
    }
  });
});
